<template>
    <div>
        <vue-headful :title="'Policies ('+policyCount+') - AMOS365'" />

        <h4 class="page-header">
            Policies ({{ policyCount }})

            <router-link to="/policies/create" class="btn btn-sm btn-info" v-if="canManagePolicies">
                <i class="fas fa-plus-square"></i> Create
            </router-link>
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="policiesTable" url="/policies" :columns="columns" :options="options">

                    <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                    </div>

                    <div slot="afterFilter" class="ml-2">

                    </div>

                    <template slot="id" slot-scope="props">
                        <router-link :to="`/policies/view/${props.row.id}`" class="btn btn-xs btn-default">View</router-link>
                    </template>

                    <template slot="policy_number" slot-scope="props">
                        <router-link :to="`/policies/view/${props.row.id}`">{{ props.row.policy_number ? props.row.policy_number : 'View' }}</router-link>
                    </template>

                    <template slot="product_name" slot-scope="props">
                        <router-link :to="`/products/view/${props.row.product_id}`">{{ props.row.product_name }}</router-link>
                    </template>

                    <template slot="agent_last_name" slot-scope="props">
                        <router-link :to="`/agents/view/${props.row.agent_id}`">{{ props.row.agent_last_name }}, {{ props.row.agent_first_name }}</router-link>
                    </template>

                    <template slot="client_last_name" slot-scope="props">
                        <router-link :to="`/clients/view/${props.row.client_id}`">{{ props.row.client_last_name }}, {{ props.row.client_first_name }}</router-link>
                    </template>

                    <template slot="entered_date" slot-scope="props">
                        <span v-if="props.row.entered_date">{{ props.row.entered_date | moment("MM/DD/YYYY") }}</span>
                    </template>

                    <template slot="effective_date" slot-scope="props">
                        <span v-if="props.row.effective_date">{{ props.row.effective_date | moment("MM/DD/YYYY") }}</span>
                    </template>

                    <template slot="signature_date" slot-scope="props">
                        <span v-if="props.row.signature_date">{{ props.row.signature_date | moment("MM/DD/YYYY") }}</span>
                    </template>

                    <template slot="is_active" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                        <label class="badge badge-warning" v-else>Inactive</label>
                    </template>

                    <template slot="is_spouse_policy" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_spouse_policy == 1">Yes</label>
                        <label class="badge badge-default" v-else>No</label>
                    </template>

                    <template slot="child_row" slot-scope="props">
                        <div>{{ props.row.notes }}</div>
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                policyCount: null,
                columns: ['policy_number', 'product_name', 'agent_last_name', 'client_last_name', 'face_amount', 'entered_date', 'effective_date', 'signature_date', 'is_spouse_policy'],
                options: {
                    headings: {
                        id: 'Actions',
                        product_name: 'Product',
                        agent_last_name: 'Agent',
                        client_last_name: 'Client',
                        policy_number: 'Policy#',
                        face_amount: 'Amount',
                        entered_date: 'Date Entered',
                        effective_date: 'Effective Date',
                        signature_date: 'Signature Date',
                        is_spouse_policy: 'For Spouse',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'clients.last_name',
                    },
                    texts:{
                        filterPlaceholder:"Search Policies",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        if(this.policyCount === null)
                        {
                            //Set the count
                            this.policyCount = response.data.count;
                        }
                        //this.$emit('policyListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        watch: {

        },

        computed: {

            canManagePolicies(){
                //Check Permissions
                return this.$root.hasPermission('policies.manage');
            },
        },

        mounted() {

        }
    }
</script>
